const animationIcon = () => {
    let icons = $('.icon-animation.animate__fadeIn')
    for(let el of icons) {
        let gif = $(el).find('img').data("image");
        let delayInMilliseconds = $(el).find('img').data("delay");
        if(delayInMilliseconds && !$(el).hasClass('active')) {
            setTimeout(function() {
                $(el).find('img').attr('src', gif);
                $(el).addClass('active');
            }, delayInMilliseconds);
        }
    }
}

module.exports = animationIcon
